import React from 'react';
import { useUser } from 'hooks';

export default Component => props => <Component {...props} user={useUser()} />;
